/**
 * helper function to add all files from a directory to the JS context for webpack processing
 * @param requireContext
 * @returns {*}
 */
function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}

//require('babel-polyfill');

// requires and returns all modules that match
requireAll(require.context("./../static", true, /.*/));
//requireAll(require.context("./../fonts", true, /.*/));
requireAll(require.context("./../config", true, /.*/));
requireAll(require.context("./../resources", true, /.*/));
requireAll(require.context("./../lib", true, /.*/));

require("./../css/equalone-ui.scss");

require("./../version.json");


var Highcharts = require('highcharts');
window.Highcharts = Highcharts;     //need this to expose Highcharts on windows object, not only on global var.
var HighChartsMore = require('highcharts-more');
HighChartsMore(Highcharts); //init more with highchart
require('highcharts/modules/solid-gauge')(window.Highcharts);

import bootstrap from 'bootstrap'
import angular from 'angular'
import uiRouter from 'angular-ui-router'
import animate from 'angular-animate'
import highCharts from 'highcharts-ng'
import translate from 'angular-translate'
import cookies from 'angular-cookies'
import cookieTranslate from 'angular-translate-storage-cookie'
import translateStaticLoader from 'angular-translate-loader-static-files'
import translateStorageLocal from 'angular-translate-storage-local'
import sanitize from 'angular-sanitize'

import EQualOneUIService from './equalone-ui/services/EQualOneUIService.js'
import CustomFieldsService from './equalone-ui/components/customfields/CustomFieldsService.js'
import LocationService from './equalone-ui/components/location/LocationService.js'

import CouponComponent from './equalone-ui/components/coupon/coupon.component';
import CustomFieldsComponent from './equalone-ui/components/customfields/customfields.component.js';
import LocationComponent from './equalone-ui/components/location/location.component';
import SpeedOMeterComponent from './equalone-ui/components/speedometer/speedometer.component';
import LoadingComponent from './equalone-ui/components/loading/loading.component';
import ResultsComponent from './equalone-ui/components/results/results.component';

import MainController from './main/MainController.js';

let mainTpl = require('./main/main.tpl.html');

export default angular.module('equalone', [uiRouter, highCharts, sanitize, cookies, translate, animate ])
    //load services first
    .service('EQualOneUIService', EQualOneUIService)
    .service('CustomFieldsService', CustomFieldsService)
    .service('LocationService', LocationService)
    //load component
    .component('coupon', CouponComponent)
    .component('customFields', CustomFieldsComponent)
    .component('location', LocationComponent)
    .component('loading', LoadingComponent)
    .component('speedometer',SpeedOMeterComponent)
    .component('results', ResultsComponent)
    //load controllers
    .controller('MainController', MainController)
    .factory('authInterceptor', ['$rootScope', '$q', '$window', function ($rootScope, $q, $window) {
        return {
            request: function (config) {
                config.headers = config.headers || {};
                if ($window.sessionStorage.getItem('token')) {
                    config.headers = {
                        'AUTH-LOGIN': $window.sessionStorage.getItem('login'),
                        'AUTH-TOKEN': $window.sessionStorage.getItem('token')
                    };
                }
                return config;
            },
            response: function (response) {
                if (response.status === 401) {
                    // handle the case where the user is not authenticated
                }
                return response || $q.when(response);
            }
        };
    }])

    .config(['$stateProvider', '$urlRouterProvider', '$compileProvider', '$httpProvider', '$translateProvider', function myAppConfig($stateProvider, $urlRouterProvider, $compileProvider, $httpProvider, $translateProvider) {

        $httpProvider.interceptors.push('authInterceptor');

        $urlRouterProvider.otherwise('/');
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|data):/);

        $stateProvider.state('loading', {
            url: '/',
            templateUrl: 'loading.html'
        });

        $stateProvider.state('login', {
            url: '/login',
            templateUrl: 'login.html'
        });

        $stateProvider.state('main', {
            url: '/main',
            controller: 'MainController',
            controllerAs: '$ctrl',
            templateUrl: mainTpl
        });

        /**
         * Configure translation parameters
         */
        var lang = navigator.language || navigator.userLanguage;
        $translateProvider.preferredLanguage(lang);
        $translateProvider.fallbackLanguage('en')
        //$translateProvider.useLocalStorage();
        $translateProvider.useSanitizeValueStrategy(null);
        $translateProvider.useStaticFilesLoader({
            prefix: 'resources/locale-',// path to translations files
            suffix: '.json'// suffix, currently- extension of the translations
        });
    }])

    .run(['$rootScope', '$http', '$state', '$q', '$timeout', function run($rootScope, $http, $state, $q, $timeout) {
        $rootScope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams, options){
                if (toState.url == '/main' && $rootScope.config == undefined) {
                    event.preventDefault();
                    $state.transitionTo('loading');

                    //retry in 500ms
                    $timeout(function() {
                        $state.transitionTo('main');
                    }, 500);
                }
                else if (toState.url == '/' && $rootScope.config !== undefined) {
                    event.preventDefault();
                }
                //event.preventDefault();
                // transitionTo() promise will be rejected with
                // a 'transition prevented' error
            });
        $q.all([
            $http.get('version.json'),
            $http.get('config/config.json')
        ])
        .then( responses => {
            var versionRes = responses[0];
            var configRes = responses[1];
            $rootScope.version = versionRes.data;

            var d = new Date();
            var n = d.getFullYear();
            $rootScope.copyright = "2009 - "+n;
            $rootScope.config = configRes.data;

            $timeout(function() {
              $state.transitionTo('main');
            }, 2000);
        });
    }])
    .constructor;



// WEBPACK FOOTER //
// ./src/equalone-ui-app.js